import { IMaterialDto, IMaterialProductDetailDto } from "@/interfaces/IMaterialDto";

export class MaterialProductDetailBase implements IMaterialProductDetailDto {
    techSpecs: string;
    viscosity: string;
    approvals: string;
    performanceLevel: string;
    constructor(t?:any){
        if (t){
            Object.assign(this,t);
        }
    }
    
}

export class MaterialPrintElementBase implements IMaterialDto{
    materialCode: string;
    description: string;
    originalDescription: string;
    packageCode: string;
    isDead: boolean;
    isPhaseOut: boolean;
    idMaterial?: string;
    idProduct?: string;
    product?: MaterialProductDetailBase;
    barCode?:string;
    constructor(t?:any){
        if (t){
            Object.assign(this,t);
        }
    }
}